import React from 'react';
import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  vacancyURLIdentifier,
} from '../../helpers';

import { NOT_FOUND_LINKS } from '../../config/constants';

import './style.scss';

const NotFound = () => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  return (
    <Container className="NotFound">
      <div className="row NotFound__row">
        <div className="col-12 col-md-6 NotFound__text">
          <h1>{t(window.location.href.includes(vacancyURLIdentifier) ? 'general.not_found_vacancy' : 'general.not_found')}</h1>
          <h3>{t('general.not_found_description')}</h3>
          <div className="NotFound__buttons">
            <Button href={`/${currentLanguage}/${NOT_FOUND_LINKS.contact}`}>{t('general.to_contact')}</Button>

            <Button className="NotFound__buttons__noborder" href={`/${currentLanguage}/${NOT_FOUND_LINKS.faq}`}>
              {t('general.to_faq')}
              <i className="icon icon-arrow-right" />
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="NotFound__image" />
        </div>
      </div>
    </Container>
  );
};

export default NotFound;
